var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"idx-skeleton",style:({
    width: _vm.width ? (_vm.width + "px") : '100%',
    height: _vm.height ? (_vm.height + "px") : '25px',
    borderRadius: _vm.radius ? (_vm.radius + "px") : '0',
  })},[(_vm.inner)?_c('div',{staticStyle:{"background":"#ffffff"},style:({
      width: _vm.width ? ((Number(_vm.width - 100)) + "px") : '100px',
      height: _vm.height ? ((Number(_vm.height - 100)) + "px") : '100px',
      borderRadius: _vm.radius ? (_vm.radius + "px") : '0',
    })}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72f6c83e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/idx-skeleton/index.vue
// module id = null
// module chunks = 